module.exports = {"id":"203884","name":"Koffi Djidji","rating":"75","photo":"./data/images/photos/2/203884.png","club":{"name":"FC Nantes","logo":"./data/images/clubs/FCNantes.png"},"positions":["DC","DG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KoffiDjidji0.json
// module id = 2394
// module chunks = 0